import { AnswerView } from "@/components/lab/TaskGroup";

const DIM_LABEL = { operational_usefulness: "Operational usefulness", data_grounding: "Data grounding", governance_safety: "Governance & safety", cost_latency_adoption: "Cost / latency / adoption" };

export const LabResult = ({ r, lab }) => (
  <div data-testid="lab-result" className="space-y-8">
    <div className="grid gap-4 md:grid-cols-[200px_1fr]">
      <div className="flex flex-col justify-center bg-trust p-6 text-white">
        <div className="font-mono text-[11px] uppercase tracking-widest text-white/60">Attempt {r.attempt_no}</div>
        <div data-testid="lab-result-total" className="font-heading text-5xl font-black">{r.total}%</div>
        <div className="text-xs text-white/70">Task accuracy {r.task_accuracy}%</div>
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        {Object.entries(r.dimensions).map(([k, d]) => (
          <div key={k} data-testid={`lab-dim-${k}`} className="border border-border bg-card p-3">
            <div className="flex justify-between text-sm"><span className="font-semibold">{DIM_LABEL[k] || k}</span><span className="font-mono">{d.score}/{d.max}</span></div>
            <div className="mt-2 h-1.5 bg-muted"><div className="h-full bg-brand-primary" style={{ width: `${(d.score / d.max) * 100}%` }} /></div>
            <p className="mt-2 text-xs text-muted-foreground">{d.full_credit}</p>
          </div>
        ))}
      </div>
    </div>
    <section>
      <h3 className="font-heading text-lg font-bold">Consequences of each decision</h3>
      <div className="mt-3 space-y-2">
        {r.choices.map((c) => (
          <div key={c.id} data-testid={`lab-consequence-${c.id}`} className={`border p-4 text-sm ${c.id === r.selected_choice ? "border-brand-action bg-brand-action/10" : "border-border bg-card"}`}>
            <div className="font-semibold">{c.id === r.selected_choice && "Your choice · "}{c.label}</div>
            <p className="mt-1">{c.consequence_if_selected}</p>
            <p className="mt-1 text-muted-foreground"><strong>Trade-off:</strong> {c.trade_off}</p>
          </div>
        ))}
      </div>
    </section>
    <section>
      <h3 className="font-heading text-lg font-bold">Task feedback</h3>
      <div className="mt-3 space-y-3">
        {r.tasks.map((t) => {
          const task = lab.tasks.find((x) => x.id === t.id);
          return (
            <details key={t.id} data-testid={`lab-task-feedback-${t.id}`} className="border border-border bg-card p-4 text-sm" open={t.score < 80}>
              <summary className="cursor-pointer font-semibold">{t.id} · {t.score}% — {task?.prompt.slice(0, 90)}…</summary>
              {t.missed.length > 0 && <p className="mt-3 text-destructive">Missed: {t.missed.join(" · ")}</p>}
              {t.extra.length > 0 && <p className="mt-1 text-brand-action">Not needed: {t.extra.join(" · ")}</p>}
              <div className="mt-3 border-l-2 border-brand-accent pl-3"><div className="overline-label mb-1">Expert answer</div><AnswerView value={t.expert_answer} /></div>
              {t.rationale && <p className="mt-3 text-muted-foreground">{t.rationale}</p>}
            </details>
          );
        })}
      </div>
    </section>
    <section className="grid gap-6 lg:grid-cols-2">
      <div><h3 className="font-heading text-lg font-bold">Decision path</h3><ol className="mt-3 space-y-2 text-sm">{r.correct_path.map((p, i) => <li key={i}>{typeof p === "string" ? p : <AnswerView value={p} />}</li>)}</ol></div>
      <div className="space-y-4">
        <div className="border-l-4 border-brand-action bg-card p-4 text-sm"><div className="overline-label mb-1">Debrief</div>{r.debrief}</div>
        <div className="border border-border bg-card p-4 text-sm"><div className="overline-label mb-1">Follow-up question</div>{r.follow_up_question}</div>
        {r.attempt_no > 1 && <div data-testid="lab-retry-adjustment" className="border border-brand-data/60 bg-brand-data/10 p-4 text-sm"><div className="overline-label mb-1">Alternate-path consequence</div>{r.retry_variant.expected_adjustment}</div>}
      </div>
    </section>
  </div>
);
